import { Compass } from "lucide-react";

export default function Logo({ size = 28, className = "" }) {
  return (
    <div
      className={`flex items-center gap-3 ${className}`}
      data-testid="stoicos-logo"
    >
      <span className="relative inline-flex items-center justify-center">
        <span
          className="absolute inset-0 rounded-full bg-gold/15 blur-md"
          aria-hidden
        />
        <Compass
          size={size}
          color="#C5A059"
          strokeWidth={1.5}
          className="relative"
        />
      </span>
      <span className="font-serif text-[1.55rem] md:text-[1.7rem] tracking-[0.02em] text-bone leading-none">
        Stoic<span className="text-gold">O</span>s
        <span className="text-gold/85">.ai</span>
      </span>
    </div>
  );
}
